module.exports = __webpack_public_path__ + "img/success copy.dee1ac2f.png";